export const sliderImages: Record<string, string> = {
	HIGH: "https://cdn-media.cure.fit/image/sugarfit-orion/v1/health-score-slider-1.svg",
	5: "https://cdn-media.cure.fit/image/sugarfit-orion/v1/health-score-slider-2.svg",
	MEDIUM: "https://cdn-media.cure.fit/image/sugarfit-orion/v1/health-score-slider-3.svg",
	2: "https://cdn-media.cure.fit/image/sugarfit-orion/v1/health-score-slider-5.svg",
	LOW: "https://cdn-media.cure.fit/image/sugarfit-orion/v1/health-score-slider-6.svg",
}

export const sliderBackgroundColor: Record<string, string> = {
	LOW: "rgba(149, 180, 101, 0.1)",
	MEDIUM: "#FBF0E6",
	HIGH: "#F8EAE8",
}

export const prescriptionPageHeader = `<div id="pdf-page-header" class="prescription-page-header $no-header-class">
    <img src="https://cdn-media.cure.fit/image/sugarfit-orion/v1/sugarfit-name-logo.svg" alt="sugarfit-logo" height="30px">
    <div class="brand-line">Your metabolic health partner</div>
</div>`

export const patientDoctorInfoTemplate = `<div id="patientAndDoctorInfo">
    $patientInfoTemplate
    $doctorInfoTemplate
</div>`

export const patientInfoTemplate = `<div>
    <div class="patient-info-label">
        <span class="info-label">Patient:&nbsp</span>
        <span class="info-value">$patientName</span>
    </div>
    <div class="patient-info-label">
        <span class="info-label">Age:&nbsp</span>
        <span class="info-value">$patientAge&nbsp;Years</span>
    </div>
    <div class="patient-info-label">
        <span class="info-label">Gender:&nbsp</span>
        <span class="info-value">$patientGender</span>
    </div>
</div>`

export const doctorInfoTemplate = `<div >
    <div class="patient-info-label">
        <span class="info-label">Doctor:&nbsp</span>
        <span class="info-value">$doctorName</span>
    </div>
    <div class="patient-info-label">
        <span class="info-value">$doctorDesignation ($doctorRegNo)</span>
    </div>
    <div class="patient-info-label">
        <span class="info-label">Date:&nbsp</span>
        <span class="info-value">$date</span>
    </div>
</div>`

export const patientVitalTableTemplate = `<div id="patientVitals" class="patient-vitals-table-wrapper">
    <div class="patient-vitals-table">
        <table>
            <thead>
                $patientVitalsHeaderRow
            </thead>
            <tbody>
                $patientVitalsItemRows
            </tbody>
        </table>
    </div>
</div>`

export const patientVitalsHeaderRow = `<tr class="value-item-row">
    <th style="width: 50%;">Health Status</th>
    <th>Result</th>
    <th>Expected Range</th>
</tr>`
export const patientVitalsItemRow = `<tr class="value-item-row">
    <td class="row-padding $customClass vital-name">$vitalName<em class="vital-unit">$vitalUnit</em></td>
    <td class=" row-padding $customClass vital-value $highlightValue">$vitalValue</td>
    <td class="row-padding $customClass ">$vitalNormalRange</td>
</tr>`

export const sectionTitle = `<div class="section-title">$sectionTitle</div>`

export const patientHealthOverviewTemplate = `<div id="healthOverview" class="health-overview">
    $sectionTitle
    <div class="card-wrapper">
        <div class="health-risk-scale" style="background: $backgroundColor">
            <div class="label-row">
                <span class="label-text">$labelText</span>
                <span class="label-score-text score-color_$score">$labelScore</span>
            </div>
            <img class="slider-image" src="$sliderImage" alt="score-scale">
            <em class="score-description">$scoreDescription</em>
        </div>
        <div class="overview-card-grid">
            $overviewCard1
            <div class="separator"></div>
            $overviewCard2
            <div class="separator"></div>
            $overviewCard3
        </div>
    </div>
</div>`

export const patientHealthOverviewCard = `<div class="overview-card">
    <div class="condition-name">$conditionName</div>
    <div class="risk-score score-color_$score">$riskScore</div>
    <em class="risk-score-normal-range">$riskNormalRange</em>
    <em class="risk-description">$riskDescription</em>
</div>`

export const goalsRecommendationTemplate = `<div id="goalRecommendation" class="goal-recommd-section">
    <div class="title-row">
        $goalSectionTitle
        $recomdSectionTitle
    </div>
    <div class="data-list-row" id="goalRecommendation-subsection">
        $goalsSection
        $recommendationSection
    </div>
</div>`

export const grListTemplate = `<div class="gr-section">
        <div class="gr-list-wrapper">
            <ol type="1">$listItems</ol>
        </div>
</div>`

export const goalsRecommendationItem = `<li class="goals-recommendation-item">
    $goalsRecommendationItem
</li>`

export const conditionAssessmentTemplate = `<div id="conditionAssessment" class="condition-assessment-section">
    $sectionTitle
    <div id="conditionAssessment-subsection" class="condition-assessment-table">
        <table>
            <thead>
                <tr>
                    <th>Parameters</th>
                    <th style="text-align: center; color: #169038; font-weight: 600">LOW RISK</th>
                    <th style="width: 105px;"></th>
                    <th style="width: 105px;"></th>
                    <th style="width: 105px;"></th>
                    <th style="width: 105px;"></th>
                    <th style="text-align: center; color: #C7452E; font-weight: 600">HIGH RISK</th>
                </tr>
            </thead>
            <tbody>
                $conditionAssessmentItemRow
            </tbody>
        </table>  
    </div>
    </div>`

export const conditionAssessmentItemRow = `<tr>
    <td class="condition-name">$conditionName</td>
    $conditionAssessmentItem
</tr>`

export const conditionAssessmentItem = `<td>
<div class="condition-value _$conditionValue $conditionActive"></div>
</td>`

export const faceBasedVitalsTemplate = `<div id="faceBasedVitals" class="face-based-vitals">
    $sectionTitle
    <div id="faceBasedVitals-subsection">
    <div class="vitals-grid">$vitalItems</div>
    </div>
</div>`

export const vitalItemTemplate = `<div>
    <div class="vital-item">
        <div class="vital-name-row">
            <img class="vital-icon" src="$vitalIcon" alt="vital-icon">
            <div class="vital-name">$vitalName</div>
        </div>
        <div class="vital-value-row">
            <div class="vital-value">$vitalValue</div>
<!--            <div class="vital-score $vitalScore">$vitalScore</div>-->
        </div>
    </div>
</div>`

export const pageFooterTemplate = `<div id="pdf-page-footer" class="prescription-page-footer $no-footer-class">
    <div class="address">Address:&nbsp$centerAddress</div>
    <div>
        Contact:&nbsp
        <a class="contactEmail" href="mailto:hello@sugarfit.com">hello@sugarfit.com</a>
    </div>
</div>`

export const bundlePackBanner = `<div class="pack-pricing">
    <div class="emi-price"><span class="currency-sign">&#8377;</span> $emiAmount / Month</div>
    <div class="emi-info">
      <div>Billed annually at &#8377;$mrp</div>
      <div class="emi-info-label">(EMI options available)</div>
    </div>
  </div>`

/*
 * edit carefitHeader template from carefitHeader template
 * remove doctorDetails template (not required)
 * edit presciptionCardHeader template
 * chief complaints template
 * public notes template
 * lab test template
 * */

export const carefitHeader = `<div class="prescription-header">
    <div class="doctor-name">$doctorName</div>
    <div class="doctor-details">
        <div class="qualification-details">$doctorQualifications</div>
        <div class="kmc-details">$doctorKmc</div>
    </div>
    <div class="prescription-logo">
        <img class="logo-big" src="https://cdn-media.cure.fit/image/sugarfit-orion/sugar-fit-logo.svg" alt="logo"/>
    </div>
</div>
`

export const prescriptionCardHeader = `<div class="prescription-card-header">
    <div>
        <div class="patient-name">
            $patientName
            <span class="patient-details">$patientDetails</span>
        </div>
        <div class="sub-details">UHID: $uhid</div>
    </div>
    <div class="flex-right">
        <div class="date prescription-date">$date</div>
        <div class="reasonForVisit">$reasonForVisit</div>
    </div>
</div>`

export const chiefComplaintsTemplate = `<div id="chiefComplaints" class="prescription-grid-row external-row">
    <div class="prescription-card-content">
        <div class="prescription-sec-heading">CHIEF COMPLAINTS</div>
        <ul id="chiefComplaints-subsection" class="prescription-description">
            $injectChiefSymptomsBody
        </ul>
    </div>
</div>`

export const chiefComplaintsItem = `<li>
    <span class="prescription-subheading">$injectSymptomDisplayValue</span>
    <span class="prescription-description">$injectSymptomDescription</span>
    <div class="item-subdesc">$injectSymptomComment</div>
</li>
`

export const publicNotesTemplate = `<div id="publicNotes" class="prescription-grid-row external-row">
    <div class="prescription-card-content">
        <div class="prescription-sec-heading">Public Notes</div>
        <ul id="publicNotes-subsection" class="prescription-description">
            <li>$injectPublicNotesBody</li>
        </ul>
    </div>
</div>`

// Current Visit Summary — top/bottom stacked layout. Each section is a
// subsection block (subheading + 3-column packed bullet list). The outer
// wrapper id MUST remain `glp1ContraindicationScreening` because
// formatPDFPages() in utils/helpers.ts walks the DOM by id to slice this
// section across PDF pages and to preserve per-page data — both the
// screening payload AND the bundled `_followupReview` ride on this single id.
//
// Page-break behaviour: the outer section heading + each subsection
// subheading use page-break-after: avoid so they stay glued to their first
// list item. We deliberately DO NOT set page-break-inside: avoid on the
// outer wrapper or on the subsection containers — headless Chrome silently
// drops elements with that rule when their content is taller than remaining
// page space. Per-row break-inside: avoid is fine (single bullet height
// fits in any remainder) and prevents a Q/A row from splitting across the
// inner CSS multi-column gap. Per-row overflow-wrap: anywhere is preserved
// so long unbroken tokens wrap inside the bullet instead of forcing
// horizontal overflow.
export const currentVisitSummaryTemplate = `<div id="glp1ContraindicationScreening" class="prescription-grid-row external-row">
    <div class="prescription-card-content">
        <div class="prescription-sec-heading" style="page-break-after: avoid; break-after: avoid;">GLP 1 Screening</div>
        <div class="cvs-stack" style="display: flex; flex-direction: column; gap: 8mm;">
            $injectCvsTopSubsection
            $injectCvsBottomSubsection
        </div>
    </div>
</div>`

// One stacked subsection: subheading + a 3-column packed bullet list. Used
// for both the Contraindication screening (top) and the GLP-1 follow-up
// review (bottom). column-fill: balance keeps the three sub-columns close
// in height; break-inside: avoid on each <li> stops a Q/A row from being
// split across the inner column gap.
export const currentVisitSummarySubsection = `<div class="cvs-subsection" style="min-width: 0;">
    <div class="cvs-subsection-title" style="font-size: 12px; font-weight: 700; color: #222; margin-bottom: 4px; padding-bottom: 2px; border-bottom: 1px solid #eee; page-break-after: avoid; break-after: avoid;">$injectCvsSubsectionTitle</div>
    <ul style="margin: 0; padding-left: 18px; font-size: 11px; line-height: 1.45; column-count: 3; column-gap: 10mm; column-fill: balance;">
        $injectCvsSubsectionRows
    </ul>
</div>`

export const currentVisitSummaryRow = `<li style="margin-bottom: 4px; overflow-wrap: anywhere; word-break: break-word; color: #222; break-inside: avoid; page-break-inside: avoid;">
    <span style="color: #555;">$injectQuestion</span>
    <span style="color: #aaa;"> — </span>
    <span style="font-weight: 600; color: #222;">$injectAnswer</span>
</li>`

export const prescriptionDiagnosisTemplate = `<div id="prescriptionDiagnosis" class="prescription-grid-row external-row">
    <div class="prescription-card-content">
        <div class="prescription-sec-heading">Diagnosis</div>
        <ul id="prescriptionDiagnosis-subsection">
            $injectDiagnosisBody
        </ul>
    </div>
</div>`

export const prescriptionDiagnosisItem = `<li>
    <span class="prescription-subheading">$injectDiagnosis</span>
    <span class="prescription-description blue-text">$injectDiagnosisType</span>
    <div class="prescription-subdesc blue-text italic">$injectDiagnosisComment</div>
</li>`

export const prescriptionLabTestsTemplate = `<div id="prescriptionLabTest" class="prescription-grid-row external-row">
    <div class="prescription-card-content">
        <div class="flex">
            <div class="prescription-sec-heading">Lab tests</div>
            <div class="extra-heading">After</div>
            <div class="extra-heading">Instructions</div>
        </div>
        <ul id="prescriptionLabTest-subsection" class="prescription-description">
            $injectLabTestBodyCont
        </ul>
    </div>
</div>`

export const prescriptionActiveFoodsTemplate = `<div id="prescriptionActiveFoodsRecommendations" class="">
    $sectionTitle
    $injectActiveFoodsBody
</div>`

export const prescriptionActiveFoodsBodyTemplate = `<div class="medicine-table-wrapper">
        <table>
            $prescriptionActiveFoodsTableHeader
            <tbody id="prescriptionActiveFoodsRecommendations-subsection">
                $activeFoodItemRows
            </tbody>
        </table>
    </div>
    $activeFoodsTagline`

export const prescriptionActiveFoodsHeader = `<thead>
    <tr>
        <th class="medicine-name-cell" style="width: 28%">Name</th>
        <th style="text-align: center; width: 24%">Dosage</th>
        <th style="text-align: center; width: 16%">Timing</th>
        <th style="text-align: center; width: 14%">Frequency</th>
        <th style="text-align: center; width: 18%">Duration</th>
    </tr>
</thead>`

export const prescriptionActiveFoodItem = `<tr>
    <td class="medicine-name-cell">
        <div class="medicine-name">$injectProductName</div>
        <em class="medicine-comment">$injectBrandName</em>
    </td>
    <td>$injectDosage</td>
    <td>$injectTiming</td>
    <td>$injectFrequency</td>
    <td>$injectDuration</td>
</tr>`

export const prescriptionActiveFoodsTagline = `<div style="color: rgba(0,0,0,0.5); font-size: 11px; font-style: italic; margin-top: 6px;">Add it to your daily foods&mdash;oats, dal, roti dough, dosa or chilla batter, or mix it in yogurt or water. Easy way to make your everyday meals protein-rich.</div>`

export const prescriptionLabTestItem = `<li class="divider">
    <div class="flex">
        <span class="prescription-subheading">$injectLabTest</span>
        <span class="item-details">$injectDuration</span>
        <span class="item-details">$injectInstructions</span>
    </div>
    $injectParameterNames
    <div class="prescription-subdesc blue-text italic">$injectDiagnosisComment</div>
</li>`

export const prescriptionMedicineHeader = `<thead>
    <tr>
        <th class="medicine-name-cell" style="width: 30%">Name</th>
        <th style="text-align: center; width: 12%">Dosage</th>
        <th style="text-align: center; width: 18%">Timing</th>
        <th style="text-align: center; width: 12%">Intake</th>
        <th style="text-align: center; width: 12%">Frequency</th>
        <th style="text-align: center; width: 16%">Duration</th>
    </tr>
</thead>`

export const prescriptionMedicinesTemplate = `<div id="prescriptionMedicines" class="">
    $sectionTitle
    $injectMedicineBody
</div>`

export const prescriptionMedicineBodyTemplate = `<div class="medicine-table-wrapper">
        <table>
            $prescriptionMedicineTableHeader
            <tbody id="prescriptionMedicines-subsection">
                $conditionAssessmentItemRow
            </tbody>
        </table>
    </div>
    $medicineSubstitutionNote`

export const prescriptionMedicineSubstitutionNote = `<div style="color: rgba(0,0,0,0.5); font-size: 11px; font-style: italic; margin-top: 6px;">Medicine substitution allowed wherever applicable, with equivalent composition and strength.</div>`

export const prescriptionMedicineItem = `<tr>
    <td class="medicine-name-cell">
        <div class="medicine-name">$injectMedicine</div>
        <em class="medicine-comment">$injectMedicineComment</em>
    </td>
    <td>$injectDosage</td>
    <td>$injectTiming</td>
    <td>$injectIntake</td>
    <td>$injectFrequency</td>
    <td>$injectDuration</td>
</tr>`

export const goalsTemplate = `<div id="goals" class="prescription-grid-row external-row">
    <div class="prescription-card-content">
        <div class="flex">
            <div class="prescription-sec-heading">Goals</div>
            <div class="extra-heading">Target Value</div>
            <div class="extra-heading">Target Date</div>
            <div class="extra-heading">Measure Frequency</div>
        </div>
        <ul id="goals-subsection" class="prescription-description">
            $injectGoalBody
        </ul>
    </div>
</div>`

export const goalItem = `<li class="divider">
    <div class="flex">
        <span class="prescription-subheading">$injectGoalName</span>
        <span class="item-details">$injectTargetValue</span>
        <span class="item-details">$injectTargetDate</span>
        <span class="item-details">$injectMeasureFrequency</span>
    </div>
</li>`

export const adherenceTemplate = `<div id="adherenceSummary" class="prescription-grid-row external-row">
    <div class="prescription-card-content">
        <div class="prescription-sec-heading">
            $injectAdherencePlanTitle
        </div>
        <div id="adherenceSummary-subsection" style="display: flex">
            $injectAdherenceBody
        </div>
    </div>
</div>`

export const adherenceItem = `<div style="display: flex; flex-direction: column; margin-right: 50px;">
    <span class="prescription-subheading">$injectAdherence</span>
    <span class="prescription-description blue-text">$injectAdherenceValue</span>
</div>`

export const adviceTemplate = `<div id="prescriptionAdvice" class="prescription-grid-row external-row">
    <div class="prescription-card-content">
        <div class="prescription-sec-heading">Advice</div>
        <ul id="prescriptionAdvice-subsection">
            $injectAdviceBody
        </ul>
    </div>
</div>`

export const followupTemplate = `<div id="followup" class="prescription-grid-row external-row">
    <div class="prescription-card-content">
        <div class="prescription-sec-heading">Followup</div>
        <ul id="followup-subsection" class="recommendation-element">
            $injectFollowupBody
        </ul>
    </div>
</div>`

export const followupItem = `<li class="prescription-description">
    <span class="prescription-subheading">$injectDate</span>
    <div class="prescription-subdesc blue-text italic">$injectFollowupComment</div>
</li>`

export const referralTemplate = `<div id="referral" class="prescription-grid-row external-row">
    <div class="prescription-card-content">
        <div class="prescription-sec-heading">Referral</div>
        <ul id="referral-subsection" class="recommendation-element">
            $injectReferralBody
        </ul>
    </div>
</div>`

export const referralItem = `<li class="prescription-description">
    <span class="prescription-subheading">$injectSpeciality</span>
    <div class="prescription-subdesc blue-text italic">$injectReferralComment</div>
</li>`

export const footerNewTemplate = `<div class="prescription-footer">
    <div class="prescription-footer-address">
        <div class="prescription-description">
            $centerAddress
        </div>
    </div>
    <div class="prescription-footer-addon">
        <span>$pageDetail</span>
    </div>
</div>`

export const signatureContTemplate = `<div class="signature-container">
    <div class="add-info">
        <span>$injectAdditionaInfoText</span>
    </div>
    <div class="signature">
        <img src="$signatureUrl" alt="signature" class="signature-img"/>
        <div class="signature-legend">Signature</div>
    </div>
</div>`

export const generalExaminationContTemplate = `<div id="generalExaminations" class="prescription-grid-row external-row">
    <div class="prescription-card-content">
        <div class="prescription-sec-heading">General Examinations</div>
        <ul id="generalExaminations-subsection">
            <li class="prescription-subheading">$injectGeneralExamBody</li>
            <div class="prescription-subdesc blue-text italic">$injectComment</div>
        </ul>
    </div>
</div>`

export const systemicExaminationsContTemplate = `<div id="systemicExaminations"  class="prescription-grid-row external-row">
    <div class="prescription-card-content">
        <div class="prescription-sec-heading">System Examinations</div>
        <ul id="systemicExaminations-subsection">
            $injectSystemicExaminationBody
        </ul>
    </div>
</div>`

export const systemicExamItemTemplate = `<li>
    <span class="prescription-subheading">$injectSystemicExamCode&nbsp;-&nbsp;</span>
    <span class="prescription-description">$injectSystemicExamComment</span>
</li>`

export const entExaminationsContTemplate = `<div id="entExamination"  class="prescription-grid-row external-row">
    <div class="prescription-card-content">
        <div class="prescription-sec-heading">ENT Examinations</div>
        <ul id="entExamination-subsection">
            $injectEntExaminationBody
        </ul>
    </div>
</div>`

export const entExamItemTemplate = `<li>
    <span class="prescription-subheading">$injectEntExamCode&nbsp;-&nbsp;</span>
    <span class="prescription-description">$injectEntExamComment</span>
</li>`

export const allergiesContTemplate = `<div id="allergies" class="prescription-grid-row external-row">
    <div class="prescription-card-content">
        <div class="prescription-sec-heading">Allergies</div>
        <ul id="vitals-subsection" class="prescription-description">
            $injectAllergies
        </ul>
    </div>
</div>`

export const bodyPartsContTemplate = `<div id="prescriptionBodyPartsCateredTo" class="prescription-grid-row external-row">
    <div class="prescription-card-content">
        <div class="prescription-sec-heading">Body Parts Catered To</div>
        <ul id="prescriptionBodyPartsCateredTo-subsection" class="recommendation-element">
            $injectBodyPartsBody
        </ul>
    </div>
</div>`

export const bodyPartsItemTemplate = `<li>
    <span class="prescription-subheading">$injectBodyPartDisplayValue</span>
    <div class="prescription-subdesc blue-text italic">$injectBodyPartComment</div>
</li>
`

export const doctorSignatureTemplate = `<div id="doctorSignature">
    <div class="signature-wrapper" id="doctorSignature-subsection">
        <div class="box-wrapper">
            <div class="signature-box">
            <img src="$signatureImage" alt="doctor-signature">
            <div class="signature-date">$signatureDate</div>
        </div>
        <div class="doctor-info">
            <div><span class="bold">Doctor Name:&nbsp</span>$doctorName</div>
            <div>$doctorQualification</div>
						<div>$doctorRegNo</div>
        </div>
        </div>
    </div>
</div>`
